import React from 'react';

import {
	ArrowGreenUpSmall,
	ArrowRedDownSmall,
	EvTag,
	IEvTagProps,
	TAG_STATUS
} from '@evinced-private/ui-common';

import './ScoreCellFormatter.scss';

interface IScoreData {
	value: number;
	percentage: number;
}

interface IScoreCellFormatterProps {
	scoreData: IScoreData;
}

export const ScoreCellFormatter: React.FC<IScoreCellFormatterProps> = ({ scoreData }) => {
	const { value, percentage } = scoreData;

	// For accessibility scores: positive percentage (score increase) = good = green arrow,
	// negative percentage (score decrease) = bad = red arrow
	// Arrow direction should match the trend direction
	const tagProps: IEvTagProps = {
		icon: undefined,
		status: TAG_STATUS.INFO,
		text: '+0%'
	};
	if (percentage > 0) {
		tagProps.icon = ArrowGreenUpSmall;
		tagProps.status = TAG_STATUS.SUCCESS;
		tagProps.text = `+${percentage.toFixed(1)}%`;
	} else if (percentage < 0) {
		tagProps.icon = ArrowRedDownSmall;
		tagProps.status = TAG_STATUS.FAILURE;
		tagProps.text = `${percentage.toFixed(1)}%`;
	}
	return (
		<div className="score-cell-formatter">
			<span className="score-value">{value}</span>
			<EvTag {...tagProps} />
		</div>
	);
};
